import { makeStyles } from '@material-ui/core';
import { primary } from 'core/ui/Colors';

export const useStyles = makeStyles({
  container: {
    maxWidth: 341,
  },
  videoWrapper: {
    position: 'relative',
    height: 192,
    aspectRatio: 16 / 9,
    margin: '0 auto',
    background: '#f3f4f6',

    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: primary,
  },
  title: {
    textAlign: 'center',
    color: primary,
    marginTop: 8,
    wordBreak: 'break-word',
  },
});
